module.exports = __webpack_public_path__ + "static/media/paulbuyse.5bbeea40.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/paulbuyse.webp
// module id = 228
// module chunks = 0